import { Injectable } from '@angular/core';

import { Product } from '@bytel/bytel-sales';

@Injectable({
    providedIn: 'root',
})
export class QuoteHelper {
    /**
     * Remove duplicate product and can sort product by name
     * @param products List of products to manage
     * @param shouldBeSortByName true/false - true by default
     * @returns List of uniq products
     */
    public static MergeProductByGencode(products: Product[], shouldBeSortByName: boolean = true): Product[] {
        const mergedProducts = products.reduce((acc, curr) => {
            if (!acc.find((product: Product) => product.gencode === curr.gencode)) {
                acc.push(curr);
            }
            return acc;
        }, []);
        return shouldBeSortByName ? this._sortProductByName(mergedProducts) : mergedProducts;
    }

    private static _sortProductByName(products: Product[]): Product[] {
        return products.sort((a: Product, b: Product) => !!a.name && a.name.localeCompare(b.name));
    }
}
